import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const VotrAccessIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 25 24">
            <path
                d="M17.9848 4.98869C17.9848 4.49881 17.7235 4.04613 17.2992 3.80119L13.0142 1.32723C12.696 1.14353 12.304 1.14353 11.9858 1.32723L11.1288 1.82202V19.1988L9.75759 18.3418V7.58085L7.65964 8.89207C7.25873 9.14264 7.01517 9.58207 7.01517 10.0548V19.0113C7.01517 19.5012 7.27652 19.9539 7.70077 20.1988L11.9858 22.6728C12.304 22.8565 12.696 22.8565 13.0142 22.6728L13.8712 22.178V4.80118L15.2424 5.65818V16.4192L17.3404 15.108C17.7413 14.8574 17.9848 14.418 17.9848 13.9452V4.98869Z"
                fill="currentColor"
            />
            <path
                d="M19.356 4.98869V15.4652L15.8869 17.6334C15.486 17.8839 15.2424 18.3234 15.2424 18.7962V21.3863L21.4858 17.7817C21.804 17.598 22 17.2585 22 16.8911V7.10893C22 6.74152 21.804 6.40202 21.4858 6.21831L19.356 4.98869Z"
                fill="currentColor"
            />
            <path
                d="M5.64397 19.0113V8.53487L9.11312 6.36665C9.51403 6.11608 9.75759 5.67665 9.75759 5.20387V2.61369L3.5142 6.21831C3.19601 6.40202 3 6.74152 3 7.10893V16.8911C3 17.2585 3.19601 17.598 3.5142 17.7817L5.64397 19.0113Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export default VotrAccessIcon; 